import React from 'react';
import SubmitButton from './SubmitButton';

const ProductDescription = ({
    description,
    brand,
    unit,
    store,
    barcode,
    quantity,
    setQuantity,
    setBarcode,
    setProductDescription,
    setProductBrand,
    setProductUnit,
    setIsFlipped,
    apiUrl,
    location,
    isLocked
}) => {
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const handleQuantityChange = (e) => {
        if (!isLocked) {
            setQuantity(e.target.value);
        }
    };

    const handleUpdateQuantity = () => {
        if (!store) {
            alert('Please select a store.');
            return;
        }

        if (!barcode) {
            alert('Please enter a product barcode.');
            return;
        }

        if (!quantity) {
            alert('Please enter a valid quantity.');
            return;
        }

        setIsSubmitting(true);

        fetch(`${apiUrl}/update-quantity`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                barcode,
                store,
                quantity: parseInt(quantity),
                location
            }),
        })
            .then((response) => response.json())
            .then((result) => {
                setIsSubmitting(false);
                if (result.success) {
                    // Clear fields AFTER success
                    setQuantity('');
                    setBarcode('');
                    setProductDescription('No product selected');
                    setProductBrand('N/A');
                    setProductUnit('N/A');
                    
                    // Show success animation
                    setIsFlipped(true);
                    setTimeout(() => setIsFlipped(false), 1500);
                } else {
                    alert('Failed to update quantity.');
                }
            })
            .catch((error) => {
                setIsSubmitting(false);
                console.error('Error updating quantity:', error);
                alert('Failed to update quantity. Please try again.');
            });
    };

    return (
        <div
            style={{
                marginTop: '20px',
                padding: '10px',
                border: '2px solid black',
                borderRadius: '5px',
                backgroundColor: '#f9f9f9',
                width: '80%',
                maxWidth: '600px',
                marginLeft: 'auto',
                marginRight: 'auto',
                textAlign: 'center',
                fontSize: '16px',
                color: '#555',
            }}
        >
            <strong>Description:</strong>
            <p>{description ? description : 'No product selected'}</p>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '20px',
                }}
            >
                <div style={{ flex: 1, margin: '0 10px', textAlign: 'center' }}>
                    <strong>Brand:</strong>
                    <p>{brand || 'N/A'}</p>
                </div>
                <div style={{ flex: 1, margin: '0 10px', textAlign: 'center' }}>
                    <strong>Unit:</strong>
                    <p>{unit || 'N/A'}</p>
                </div>
                <div style={{ flex: 1, margin: '0 10px', textAlign: 'center' }}>
                    <strong>Quantity:</strong>
                    <input
                        type="number"
                        value={quantity}
                        onChange={handleQuantityChange}
                        placeholder="Enter Qty"
                        inputMode="numeric"
                        disabled={isLocked}
                        style={{
                            padding: '5px',
                            fontSize: '14px',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                            width: '100%',
                            cursor: isLocked ? 'not-allowed' : 'text',
                            opacity: isLocked ? 0.6 : 1,
                        }}
                    />
                </div>
            </div>
            <SubmitButton 
                onClick={handleUpdateQuantity} 
                label={isSubmitting ? "Updating..." : "Submit"}
                disabled={isSubmitting || isLocked}
            />
        </div>
    );
};

export default ProductDescription;